/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styled from 'styled-components';
import { DashboardService } from '../../../services';
import NetworkChart3 from '../../dashboards/Widgets/NetworkChart/index3';


const Styles = styled.div`
	width: 565px;
  height: 400px;
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

function SupplyChainMapSelect({
  authentication: { user },
  props = {},
  formsValue = {},
  call = null,
  value = null,
  repeatValues = null,
  onNewSetValue = null,
  name = null,
  inputName = null,
  dataId = null,
  onChange = () => { },
}) {
  const [model, setModel] = useState(undefined);

  useEffect(() => {
    if (dataId) {
      DashboardService.getSupplyChainMap(dataId, true).then((res) => setModel(res.data));
    }
  }, [dataId])

  useEffect(() => {
    if (model && model.children) {
      const { children, ...data } = model;
      setModel(data);
    }
  }, [model])

  const removeMineSites = (data) => {
    if (data.parents) {
      data.parents = data.parents.filter(p => p.type !== 'mineSite');
      data.parents.map(parent => removeMineSites(parent));
    }
    return data;
  }

  return <Styles>
    {model ? <NetworkChart3
      uniqueId={dataId}
      value={value}
      tradeData={model}
      selectable={true}
      onChange={onChange} /> : null}
  </Styles>
}

const mstp = ({ authentication }) => ({ authentication });

export default connect(mstp)(SupplyChainMapSelect);
